import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table13 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [PowerbiData, setPowerbiData] = useState(null);
  const [previousData, setPreviousData] = useState(null);
  const [locationList, setLocation] = useState(null);
  const [unitList, setUnit] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });
    const filter = obj.filter((item) => item.timeText === "" || item.timeText === null);
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {
          if (response.data.data[0].list.length == 0) {
            getNewData();
          } else {
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
              if (props.type === "new" && props.newHeadId) {
                if (response.data.data[0].yearId != props.yearId) {
                  data.timeHr = "";
                  data.timeText = "";
                }
              }
              return data;
            });
            setLoading(false);
            setPowerbiData(dataView);
          }
        } else {
          setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
            data.timeHr = "";
            data.timeText = "";
            return data;
          });
          setPowerbiData(dataView);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getLocation = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table13/table13location`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("setType", response.data);
        setLocation(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table13/table13location", error);
      });
  };

  const getUnit = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table13/table13unit`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setUnit(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table13/table13unit", error);
      });
  };

  useEffect(() => {
    getLocation();
    getUnit();
    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = { ...datas[0] };
    data.timeHr = "";
    data.timeText = "";
    setPowerbiData(datas.concat([data]));
  };
  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  return (
    <Row>
      {props.tableTabSettingId == 29 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Month_TH</th>
                  <th scope="col">Import_Export</th>
                  <th scope="col">Time</th>
                  <th scope="col">Unit</th>
                  <th scope="col">Location </th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                    <td>{index + 1}</td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.monthId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "monthId", e.target.value);
                        }}
                      >
                        <option value="1">มกราคม</option>
                        <option value="2">กุมภาพันธ์</option>
                        <option value="3">มีนาคม</option>
                        <option value="4">เมษายน</option>
                        <option value="5">พฤษภาคม</option>
                        <option value="6">มิถุนายน</option>
                        <option value="7">กรกฎาคม</option>
                        <option value="8">สิงหาคม</option>
                        <option value="9">กันยายน</option>
                        <option value="10">ตุลาคม</option>
                        <option value="11">พฤศจิกายน</option>
                        <option value="12">ธันวาคม</option>
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.importExportId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "importExportId", e.target.value);
                        }}
                        require
                      >
                        <option value={1}> Import </option>
                        <option value={2}> Export </option>
                      </FormSelect>
                    </td>
                    <td>
                      <FormInput
                        type="number"
                        value={item.timeText}
                        placeholder="Value"
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "timeText", e.target.value);
                        }}
                      />
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.unitId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "unitId", e.target.value);
                        }}
                        require
                      >
                        {unitList != null &&
                          unitList.length > 0 &&
                          unitList.map((item) => {
                            return (
                              <option value={item.unitId}>
                                {item.unitName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                        placeholder="- เลือก -"
                        value={item.locationId}
                        disabled={!onEditCurrent}
                        onChange={(e) => {
                          onSetdata(index, "locationId", e.target.value);
                        }}
                        require
                      >
                        {locationList != null &&
                          locationList.length > 0 &&
                          locationList.map((item) => {
                            return (
                              <option value={item.locationId}>
                                {item.locationName}
                              </option>
                            );
                          })}
                      </FormSelect>
                    </td>
                  </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 30 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Month_TH</th>
                  <th scope="col">Import_Export</th>
                  <th scope="col">time_text</th>
                  <th scope="col">time_hr</th>
                  <th scope="col">Unit</th>
                  <th scope="col">Location </th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={7}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.monthId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "monthId", e.target.value);
                          }}
                        >
                          <option value="1">มกราคม</option>
                          <option value="2">กุมภาพันธ์</option>
                          <option value="3">มีนาคม</option>
                          <option value="4">เมษายน</option>
                          <option value="5">พฤษภาคม</option>
                          <option value="6">มิถุนายน</option>
                          <option value="7">กรกฎาคม</option>
                          <option value="8">สิงหาคม</option>
                          <option value="9">กันยายน</option>
                          <option value="10">ตุลาคม</option>
                          <option value="11">พฤศจิกายน</option>
                          <option value="12">ธันวาคม</option>
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.importExportId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "importExportId", e.target.value);
                          }}
                          require
                        >
                          <option value={1}> Import </option>
                          <option value={2}> Export </option>
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="time"
                          value={item.timeText}
                          placeholder="Value"
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "timeText", e.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.timeHr}
                          placeholder="Value"
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "timeHr", e.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.unitId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "unitId", e.target.value);
                          }}
                          require
                        >
                          {unitList != null &&
                            unitList.length > 0 &&
                            unitList.map((item) => {
                              return (
                                <option value={item.unitId}>
                                  {item.unitName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.locationId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "locationId", e.target.value);
                          }}
                          require
                        >
                          {locationList != null &&
                            locationList.length > 0 &&
                            locationList.map((item) => {
                              return (
                                <option value={item.locationId}>
                                  {item.locationName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={7}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 31 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Month_TH</th>
                  <th scope="col">Import_Export</th>
                  <th scope="col">Avg_Time</th>
                  <th scope="col">Unit</th>
                  <th scope="col">Location </th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.monthId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "monthId", e.target.value);
                          }}
                        >
                          <option value="1">มกราคม</option>
                          <option value="2">กุมภาพันธ์</option>
                          <option value="3">มีนาคม</option>
                          <option value="4">เมษายน</option>
                          <option value="5">พฤษภาคม</option>
                          <option value="6">มิถุนายน</option>
                          <option value="7">กรกฎาคม</option>
                          <option value="8">สิงหาคม</option>
                          <option value="9">กันยายน</option>
                          <option value="10">ตุลาคม</option>
                          <option value="11">พฤศจิกายน</option>
                          <option value="12">ธันวาคม</option>
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.importExportId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "importExportId", e.target.value);
                          }}
                          require
                        >
                          <option value={1}> Import </option>
                          <option value={2}> Export </option>
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.timeText}
                          placeholder="Value"
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "timeText", e.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.unitId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "unitId", e.target.value);
                          }}
                          require
                        >
                          {unitList != null &&
                            unitList.length > 0 &&
                            unitList.map((item) => {
                              return (
                                <option value={item.unitId}>
                                  {item.unitName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.locationId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "locationId", e.target.value);
                          }}
                          require
                        >
                          {locationList != null &&
                            locationList.length > 0 &&
                            locationList.map((item) => {
                              return (
                                <option value={item.locationId}>
                                  {item.locationName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={6}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 32 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Location</th>
                  <th scope="col">distance_Export</th>
                  <th scope="col">distance_Import</th>
                  <th scope="col">unit</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={5}> Loading... </td>
                  </tr>
                </tbody>
              ) : locationList != null && locationList.length > 0 ? (
                <tbody className="table-middle">
                  {locationList.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.locationName}</td>
                      <td>{item.distanceExport}</td>
                      <td>{item.distanceImport}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.unitId}
                          disabled
                          onChange={(e) => {
                            onSetdata(index, "unitId", e.target.value);
                          }}
                          require
                        >
                          {unitList != null &&
                            unitList.length > 0 &&
                            unitList.map((item) => {
                              return (
                                <option value={item.unitId}>
                                  {item.unitName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={5}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabMaster ? null : props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          {onEditCurrent ? (
            <Button
              theme="success"
              onClick={() => onCeateTable()}
              style={{ float: "right", width: 200 }}
            >
              บันทึกข้อมูล
            </Button>
          ) : props.status == 0 && props.userType != 3 ? (
            <Button
              theme="success"
              onClick={() => props.onApproveTable()}
              style={{ float: "right", width: 200 }}
            >
              อนุมัติเผยแพร่
            </Button>
          ) : null}
          {!onEditCurrent && (
            <Button
              outline
              theme="secondary"
              onClick={() => setOnEditCurrent(true)}
              style={{ float: "right", width: 200, marginRight: 20 }}
            >
              แก้ไขข้อมูล
            </Button>
          )}
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <Button
            theme="success"
            onClick={() => onCeateTable()}
            style={{ float: "right", width: 200 }}
          >
            บันทึกข้อมูล
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Table13;
